'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
// import mqttclient from '../../../mqttclient/lib/mqttclient'


var _constants = require('../common/constants');

var Constants = _interopRequireWildcard(_constants);

var _helpers = require('../common/helpers');

var Helpers = _interopRequireWildcard(_helpers);

var _chatreducer = require('./chatreducer');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageComposer = function () {
    function MessageComposer(context) {
        var _this = this;

        _classCallCheck(this, MessageComposer);

        this.messageHandler = function (action, payload) {
            var publish = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var packet = void 0;
            switch (action) {
                case Constants.MESSAGE_ACTION_TYPING:
                    packet = _this.userStartTyping(payload);
                    // if (payload.length === 0) {
                    //     this.textLength = 0
                    // }
                    // if (payload.length > (this.textLength + Constants.CHAT_USER_START_TYPING_CHARACTER_LENGTH)) {
                    //     //packet = this.composeUserStartTyping(text)
                    //     packet = this.userStartTyping(payload)
                    //     this.textLength = payload.length
                    // }
                    // if (payload.length < (this.textLength - Constants.CHAT_USER_START_TYPING_CHARACTER_LENGTH)) {
                    //     packet = this.userStartTyping(payload)
                    //     this.textLength = payload.length
                    // }
                    break;

                case Constants.MESSAGE_ACTION_SUBMIT:
                    packet = _this.newMessage(payload);

                    // we will display the message intantly with out waiting for server response
                    // once the same message received from server, it will be acknowledge visually  
                    var chatMessage = {
                        meetingId: _this.invocationContext.props.meetingId,
                        message: packet.payload,
                        call_type: Constants.MESSAGE_CALL_TYPE_SEND
                    };
                    _this.invocationContext.props.dispatch((0, _chatreducer.addChatMessage)(chatMessage));
                    _this.textLength = 0; // reset
                    break;

                case Constants.MESSAGE_ACTION_FOCUS:
                    break;

                case Constants.CHAT_ACTION_FILE_SHARE:
                    packet = _this.fileShareMessage(payload);
                    chatMessage = {
                        meetingId: _this.invocationContext.props.meetingId,
                        message: packet.payload
                    };
                    _this.invocationContext.props.dispatch((0, _chatreducer.addChatMessage)(chatMessage));
                    break;

                case Constants.MESSAGE_ACTION_JOIN:
                    packet = _this.mqttJoinEvent(payload);
                    break;

                default:
                    console.warn('onMessageEntered: Unknown action ' + action);
            }
            // publish to MQTT
            if (packet && publish) {
                packet.payload = JSON.stringify(packet.payload);
                (0, _helpers.getChatConfig)().mqttService.publish(packet);
            }
        };

        this.invocationContext = context;
        this.textLength = 0;

        this.setInvocationContext = this.setInvocationContext.bind(this);
        this.messageHandler = this.messageHandler.bind(this);
        this.newMessage = this.newMessage.bind(this);
        this.userStartTyping = this.userStartTyping.bind(this);
        this.getPacket = this.getPacket.bind(this);
    }

    _createClass(MessageComposer, [{
        key: 'newMessage',
        value: function newMessage(text) {
            //{"message_id":"ac22345bcdfe35465","disp_msg":"custom remarks","server_timestamp":"43334353",
            //"topic":"in.jomaange.jmapp.pro/chat","type":"chat","action":"message_receive",
            //"data":{"meeting_id":"100","title":"chat 100","message":"I need help on get ting home key from office desk zxcvbn",
            //"sender_id":"433","sender_name":"swiggy_merchant","sender_image_url":"//localhost:8080/static/img/user-avatar-160x160.png",
            //"sender_timestamp":1492863513019}}
            var chatMessage = {
                type: Constants.CHAT_TYPE,
                action: Constants.CHAT_ACTION_MESSAGE_NEW,
                message_id: Helpers.genUUID(),
                disp_msg: "chat message",
                topic: this.invocationContext.topic,
                delivery_status: Constants.MESSAGE_DELIVERY_STATUS_INFLIGHT,
                data: {
                    meeting_id: this.invocationContext.props.meetingId,
                    title: this.invocationContext.props.meetingTitle,
                    message: text,
                    sender_id: this.invocationContext.user.id,
                    sender_timestamp: Helpers.getCurrentTimeStampInUnix()
                }
            };

            return this.getPacket(chatMessage);
        }
    }, {
        key: 'userStartTyping',
        value: function userStartTyping(text) {
            var chatMessage = {
                type: Constants.CHAT_TYPE,
                action: Constants.CHAT_ACTION_USER_START_TYPING,
                message_id: Helpers.genUUID(),
                disp_msg: "chat user typing message",
                topic: this.invocationContext.topic,
                delivery_status: Constants.MESSAGE_DELIVERY_STATUS_DELIVERED,
                data: {
                    meeting_id: this.invocationContext.props.meetingId,
                    message: text,
                    sender_id: this.invocationContext.user.id,
                    sender_timestamp: Helpers.getCurrentTimeStampInUnix()
                }
            };

            return this.getPacket(chatMessage);
        }
    }, {
        key: 'mqttJoinEvent',
        value: function mqttJoinEvent(payload) {
            console.log('mqtt join event payload.. ', payload);

            var chatMessage = {
                "message_id": Helpers.genUUID(),
                "disp_msg": "Join chat event",
                "topic": this.invocationContext.topic,
                "type": "chat",
                "action": "user_join",
                "data": {
                    "meeting_id": payload.meeting_Id,
                    "title": "This meeting is about?",
                    "sender_id": payload.sender_Id,
                    "message": payload.user_Name + " joined chat",
                    "sender_timestamp": Helpers.getCurrentTimeStampInUnix()
                }
            };

            return this.getPacket(chatMessage);
        }
    }, {
        key: 'getPacket',
        value: function getPacket(chatMessage) {
            return {
                topic: this.invocationContext.topic,
                payload: chatMessage,
                qos: Constants.MQTT_QOS
            };
        }
    }, {
        key: 'setInvocationContext',
        value: function setInvocationContext(context) {
            console.log('setInvocationContext');
            this.invocationContext = context;
        }
    }, {
        key: 'fileShareMessage',
        value: function fileShareMessage(payload) {
            var chatMessage = {
                type: Constants.CHAT_TYPE,
                action: Constants.CHAT_ACTION_FILE_SHARE,
                message_id: Helpers.genUUID(),
                disp_msg: "file share message",
                topic: this.invocationContext.topic,
                delivery_status: Constants.MESSAGE_DELIVERY_STATUS_INFLIGHT,
                data: {
                    meeting_id: this.invocationContext.props.meetingId,
                    title: this.invocationContext.props.meetingTitle,
                    files: payload.localFileUrls,
                    caption: payload.caption,
                    message: payload.text,
                    sender_id: this.invocationContext.user.id,
                    sender_timestamp: Helpers.getCurrentTimeStampInUnix()
                }
            };
            return this.getPacket(chatMessage);
        }
    }]);

    return MessageComposer;
}();

exports.default = MessageComposer;


// WEBPACK FOOTER //
// ../chat/lib/components/messagecomposer.js